import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { PSPMarkdownModule } from 'components/psp/PSPMarkdown';
import PSPImage from 'components/psp/PSPImage/PSPImage';
import { PSPFAQ } from 'components/psp/PSPFAQ';
import { PSPTable } from 'components/psp/PSPTable';
import { PSPUnitCards } from 'components/psp/PSPUnitCards';
import { PSPList } from 'components/psp/PSPList';
import { PSPCities } from 'components/psp/PSPCities';
import { PSPSectionHeader } from 'components/psp/PSPSectionHeader';
import {
	PSPSizeChartSection,
	FeaturedContent,
	PSPLinks,
	PSPStorageNearYou,
	PSPHero,
	PSPReviewSection,
	UnitList,
	PSPVideo,
	PSPContentSection,
	FAQSection,
	CTABlock,
	PLPFacilitiesSection,
	AlternateContentSection,
	CardBlockSection,
	IconContentBlock,
	SecondaryNav,
} from '../../organisms';
import { SectionHeader } from 'components/molecules/SectionHeader';

const PortableStorageComparison = loadable(() =>
	import(/* webpackChunkName: "PortableStorage" */ 'components/brand/PortableStorageComparison/PortableStorageComparison').then(m => ({ default: m.PortableStorageComparison }))
);
const PortableStoragePromoCards = loadable(() =>
	import(/* webpackChunkName: "PortableStorage" */ 'components/brand/PortableStoragePromoCards/PortableStoragePromoCards').then(m => ({ default: m.PortableStoragePromoCards }))
);

export const PSPPageSectionsMap = {
	markdownSection: PSPMarkdownModule,
	videoSection: PSPVideo,
	imageSection: PSPImage,
	tableSection: PSPTable,
	faqSection: PSPFAQ,
	unitCards: PSPUnitCards,
	listSection: PSPList,
	citiesSection: PSPCities,
	newVideoSection: PSPVideo,
	sectionHeader: PSPSectionHeader,
	commonSectionHeader: SectionHeader,
	hero: PSPHero,
	reviews: PSPReviewSection,
	storageNearYou: PSPStorageNearYou,
	unitList: UnitList,
	links: PSPLinks,
	featuredContent: FeaturedContent,
	sizeChart: PSPSizeChartSection,
	content: PSPContentSection,
	alternatingContent: AlternateContentSection,
	cardBlockContent: CardBlockSection,
	faqs: FAQSection,
	facilitiesNearYou: PLPFacilitiesSection,
	inlineCTA: CTABlock,
	PortableStorageComparison: PortableStorageComparison,
	PortableStoragePromoCards: PortableStoragePromoCards,
	IconContentBlock: IconContentBlock,
	SecondaryNav: SecondaryNav,
};

function PSPModuleFactory({ type, props, children }) {
	if (type in PSPPageSectionsMap) {
		const Component = PSPPageSectionsMap[type];
		return React.createElement(Component, { ...props }, children);
	}
	return null;
}

PSPModuleFactory.propTypes = {
	children: PropTypes.node,
	props: PropTypes.object,
	type: PropTypes.string,
};

export default PSPModuleFactory;
